
  var _styles = {
  "city-explore-progress-card": {
    "display": "flex",
    "flexDirection": "column",
    "width": "9.36rem",
    "height": "6.72rem",
    "borderRadius": "0.48rem",
    "overflow": "hidden",
    "position": "relative"
  },
  "city-explore-progress-card__background": {
    "borderRadius": "0.48rem",
    "position": "absolute",
    "zIndex": 0,
    "top": "0.02667rem",
    "left": "0.02667rem",
    "width": "9.30667rem",
    "height": "6.66667rem"
  },
  "city-explore-progress-card__content-wrapper": {
    "position": "relative",
    "zIndex": 1,
    "display": "flex",
    "flexDirection": "column",
    "width": "9.36rem",
    "height": "6.72rem",
    "borderRadius": "0.48rem",
    "justifyContent": "flex-start",
    "alignItems": "center",
    "paddingTop": 0,
    "paddingRight": "0.29333rem",
    "paddingBottom": 0,
    "paddingLeft": "0.29333rem"
  },
  "city-explore-progress-card__city-img": {
    "width": "0.42667rem",
    "height": "0.42667rem"
  },
  "city-explore-progress-card__title-wrapper": {
    "marginTop": "0.26667rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "city-explore-progress-card__title": {
    "fontWeight": "500",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem"
  },
  "city-explore-progress-card__landmark-row": {
    "width": "100%",
    "marginTop": "0.33333rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "overflow": "hidden"
  },
  "city-explore-progress-card__landmark": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "city-explore-progress-card__progress-bar": {
    "display": "flex",
    "flexDirection": "row",
    "width": "100%",
    "height": "0.16rem",
    "marginTop": "0.24rem",
    "borderRadius": "13.32rem",
    "backgroundColor": "rgb(255,250,219)"
  },
  "city-explore-progress-card__progress-bar-inner": {
    "height": "0.16rem",
    "borderRadius": "13.32rem"
  },
  "city-explore-progress-card__score-wrapper": {
    "width": "9.36rem",
    "marginTop": "0.2rem",
    "display": "flex",
    "flexDirection": "row",
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem",
    "justifyContent": "space-between",
    "alignItems": "center"
  },
  "city-explore-progress-card__score-text": {
    "fontSize": "0.32rem",
    "lineHeight": "0.4rem",
    "fontWeight": "600",
    "color": "rgb(31,24,18)"
  },
  "city-explore-progress-card__score-total": {
    "marginTop": "0.10667rem",
    "fontSize": "0.26667rem",
    "textAlign": "right",
    "color": "rgb(144,134,117)",
    "fontWeight": "500"
  },
  "city-explore-progress-card__action-row": {
    "width": "100%",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "marginTop": "0.32rem"
  },
  "city-explore-progress-card__action-btn": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center",
    "width": "1.28rem",
    "height": "1.28rem",
    "position": "relative"
  },
  "city-explore-progress-card__action-btn-img": {
    "width": "1.28rem",
    "height": "1.28rem"
  },
  "city-explore-progress-card__action-btn-background": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "1.28rem",
    "height": "1.28rem",
    "borderRadius": "0.24rem",
    "zIndex": 0
  },
  "city-explore-progress-card__action-btn-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.24rem"
  },
  "city-explore-progress-card__action-center-btn": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "width": "5.33333rem",
    "height": "1.28rem",
    "marginLeft": "0.16rem",
    "marginRight": "0.16rem",
    "borderRadius": "0.8rem",
    "position": "relative",
    "overflow": "visible"
  },
  "city-explore-progress-card__action-center-btn-background": {
    "width": "5.33333rem",
    "height": "1.28rem",
    "position": "absolute",
    "borderRadius": "0.8rem",
    "zIndex": 0
  },
  "city-explore-progress-card__action-center-btn-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.48rem",
    "textAlign": "center"
  },
  "city-explore-progress-card__hand-wrapper": {
    "position": "absolute",
    "zIndex": 999,
    "width": "1.6rem",
    "height": "1.6rem",
    "right": "-0.33333rem",
    "bottom": "-0.4rem"
  }
};



  module.exports = _styles;
  